import * as RouteConstants from '../../constants/routeConstants';

const supportedVerificationRoutes = [{
  path: RouteConstants.RENEWAL,
  trackingValue: 'MyRAC_RenewalFromEmailVerificatonRequired',
},
{
  path: RouteConstants.PRODUCT_UPGRADE_PAGE,
  trackingValue: 'MyRAC_UpgradeFromEmailVerificatonRequired',
},
{
  path: RouteConstants.RAC_LOYALTY_REWARDS,
  trackingValue: 'MyRAC_RewardClaimFromEmailVerificatonRequired',
}];

export default supportedVerificationRoutes;
